import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, take } from 'rxjs';
import { GeneralService } from './general.service';
import { environment } from '../../../environments/environment';
import {
  CotStatus,
  DataQuotation,
  PageWorkflow,
  WorkflowTask,
} from '../models/workflow-model/workflow.model';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  public URL_API = environment.apiURLNew;
  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public GetDataQuotation(id: number): Observable<DataQuotation[] | null> {
    return this.http
      .get<DataQuotation[] | null>(this.URL_API + `/api/Workflow/GetDataQuotation/${id}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public QuotationByfilters(commonFilterRequest: any): Observable<any | null> {
    return this.http
      .post<any>(this.URL_API + '/api/Quotation/QuotationByfilters', commonFilterRequest)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public GetCotStatus(): Observable<CotStatus[] | null> {
    return this.http.get<CotStatus[]>(this.URL_API + '/GetCotStatus').pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public GetPagesByStatus(paramsInput: {
    status: string | number;
  }): Observable<PageWorkflow[] | null> {
    const params = this.generalService.buildParams(paramsInput);
    return this.http
      .get<PageWorkflow[]>(this.URL_API + '/pages-by-status', { params: params })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public GetWorkflowTasks(
    quotationId: number,
    paramsInput: {
      workflowStatus: string | null;
    },
  ): Observable<WorkflowTask[] | null> {
    const params = this.generalService.buildParams(paramsInput);
    return this.http
      .get<WorkflowTask[]>(this.URL_API + `/getWorkflowTasks/${quotationId}`, { params: params })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public updateWorkflowTask(body: {
    isChecked: boolean;
    quotationId: number;
    quotationTaskId: number;
    userId: number;
    value: string;
  }): Observable<any | null> {
    return this.http.post<any>(this.URL_API + '/updateWorkflowTask', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }
}
